










































































































import Component from 'vue-class-component';
import FeedbackComponent from '@/components/base/FeedbackComponent';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import {
  CITIES,
  FORM101_DATA,
  FORM101_META_DATA,
  FORM_READ_ONLY_MODE,
  GET_CITIES,
  SET_FORM101_DATA,
} from '@/types/form.types';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import { City } from '@/models/form/PersonalDetails.model';
import { USER_DETAILS } from '@/types/authentication.types';
import { UserDetails } from '@/models/UserDetails.model';
import { Form101MetaData } from '@/models/form/Form101MetaData.model';

@Component({})
export default class AddressDetails extends FeedbackComponent {

  @Action(GET_CITIES, StoreNamespace.FORM) public getCities;

  @Mutation(SET_FORM101_DATA, StoreNamespace.FORM) public setForm101Data;

  @Getter(FORM101_META_DATA, StoreNamespace.FORM) public form101MetaData!: Form101MetaData;
  @Getter(CITIES, StoreNamespace.FORM) public cities!: City[];
    @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;
    @Getter(FORM_READ_ONLY_MODE, StoreNamespace.FORM) public formReadOnlyMode!: boolean;

    public mounted() {
      if (!this.form101MetaData.settlementNameUse) {
        this.getCities(this.form101Data.taxYear);
      }
    }

    public updateForm101Data(newVal: any, property: string) {
      this.setForm101Data({ ...this.form101Data, [property]: newVal });
    }

    public zipCodeLink() {
      window.open('https://mypost.israelpost.co.il/שירותים/איתור-מיקוד');
    }
  }
